<template>
  <v-chip :color="color" dark small>
    {{ status }}
  </v-chip>
</template>

<script>

export default {
  name: "TableStatus",
  props: {
    data: Object,
  },
  data: () => ({
    colors: {
      pending: 'orange',
      edit: 'red',
      accept: 'green'
    },
    statuses: {
      pending: 'منتظر تایید',
      edit: 'رد شده',
      accept: 'تایید شده'
    }
  }),
  computed: {
    color() {
      return this.colors[this.data.auth_validate] || 'red'
    },
    status() {
      return this.statuses[this.data.auth_validate] || '-'
    }
  }
}
</script>
